import React, { Component } from "react";
import { connect } from "react-redux";
import { borraRubro } from "../actions/admin";
import AdminMenu from "../components/admin_menu";

class AdminRubros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      estados: ["NULO", "ACTIVO"]
    };
    this.verRubro = this.verRubro.bind(this);
    this.borra = this.borra.bind(this);
  }

  componentDidMount() {
    if (!this.props.usuario.user) {
      this.props.history.push("/login");
    }
  }

  componentDidUpdate(prevProps, prevState) {}

  borra(id) {
    if (window.confirm("ESTA POR BORRAR UN ELEMENTO, DESEA CONTINUAR?")) {
      console.log("CONFIRMO");
      this.props.borraRubro(id);
    } else {
      console.log("RECHAZO");
    }
  }

  verRubro(id) {
    this.props.history.push(
      "/admin/rubro/" + id
    );
  }

  limpiaCarro() {}

  render() {
    const rubros = this.props.productos.rubros.map((rubro, i) => {
      return <tr key={i}>
          <td>{rubro.nombre}</td>
          <td>
            <button type="button" className="btn btn-info" onClick={e => this.verRubro(rubro.id)}>
              <i className="fas fa-pencil-alt" />
            </button>
          </td>
          <td>
          <button type="button" className="btn btn-info" onClick={e => this.borra(rubro.id)}>
              <i className="fas fa-trash-alt" />
            </button>
          </td>
        </tr>;
    });

    return (
      <div className="container">
        <section className="row mb-5 sombraHead mt-3 clearfix">
          <div className="col-md-3 mb-3">
            <AdminMenu />
          </div>

          <div className="col-md-9 p-3">
            <div>
              <h1 className="display-4">Rubros</h1>
            </div>

            <table className="table">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th scope="col" />
                  <th>
                    <button
                      type="button"
                      className="btn btn-info"
                      onClick={e => this.props.history.push("/admin/rubro/")}
                    >
                      <i className="fas fa-plus" />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>{rubros}</tbody>
            </table>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    productos: state.productos,
    usuario: state.usuario
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    borraRubro: id_rubro => {
      dispatch(borraRubro(id_rubro))
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminRubros);



// WEBPACK FOOTER //
// ./src/containers/admin_rubros.js